/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Meta_TitleInputs */

const en_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search, Shoot Share Connect`)
};

const es_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar — Shoot Share Connect`)
};

const fr_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche — Shoot Share Connect`)
};

const de_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche — Shoot Share Connect`)
};

const ja_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索 — Shoot Share Connect`)
};

const zh_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 — Shoot Share Connect`)
};

const ar_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث — Shoot Share Connect`)
};

const id_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencarian — Shoot Share Connect`)
};

const it_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca — Shoot Share Connect`)
};

const ru_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск — Shoot Share Connect`)
};

const pt_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar — Shoot Share Connect`)
};

const ko_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색 — Shoot Share Connect`)
};

/**
* | output |
* | --- |
* | "Search, Shoot Share Connect" |
*
* @param {Search_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_meta_title = /** @type {((inputs?: Search_Meta_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Meta_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_meta_title(inputs)
	if (locale === "es") return es_search_meta_title(inputs)
	if (locale === "fr") return fr_search_meta_title(inputs)
	if (locale === "de") return de_search_meta_title(inputs)
	if (locale === "ja") return ja_search_meta_title(inputs)
	if (locale === "zh") return zh_search_meta_title(inputs)
	if (locale === "ar") return ar_search_meta_title(inputs)
	if (locale === "id") return id_search_meta_title(inputs)
	if (locale === "it") return it_search_meta_title(inputs)
	if (locale === "ru") return ru_search_meta_title(inputs)
	if (locale === "pt") return pt_search_meta_title(inputs)
	return ko_search_meta_title(inputs)
});